import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'

export const ConnectionLink = ({url}: {url: string}) => {
  const intl = useIntl()

  return (
    <div className='fw-bolder text-gray-600 store-connect-page__link'>
      {intl.formatMessage({id: 'FOR_ADDITIONAL_GUIDANCE_VISIT_THIS'})}{' '}
      {/* TODO: [N] handle with new button style in SB-615 */}
      <Link to={url} target='_blank' className='text-decoration-underline'>
        {intl.formatMessage({id: 'HELP_CENTER_ARTICLE'})}
      </Link>
      .
    </div>
  )
}
